var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "applianceModal",
        tabindex: "-1",
        role: "dialog",
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-centered modal-xl",
          attrs: { role: "document" },
        },
        [
          _c("div", { staticClass: "modal-content px-md-5 py-md-4" }, [
            _c("div", { staticClass: "modal-header border-0" }, [
              _c("h2", { staticClass: "h2" }, [_vm._v(_vm._s(_vm.heading))]),
              _vm._v(" "),
              _vm._m(0),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                !_vm.isCompleted
                  ? [
                      !_vm.selectedForm
                        ? [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-start justify-content-between flex-wrap",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "mb-4" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-secondary mb-4",
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.selectForm("person")
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Žádost o individuální příspěvek – fyzická osoba\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.$attrs["individual-form-document"]
                                      .length
                                      ? [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "font-size-lg text-primary",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Případně si můžete formulář stáhnout:\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            { staticClass: "font-size-lg" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "text-secondary",
                                                  attrs: {
                                                    href: _vm.$attrs[
                                                      "individual-form-document"
                                                    ],
                                                    download: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "Žádost o individuální příspěvek - fyzická osoba.pdf"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "mb-4" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-secondary mb-4",
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.selectForm("company")
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Žádost o poskytnutí příspěvku - právnická osoba\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.$attrs["company-form-document"].length
                                      ? [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "font-size-lg text-primary",
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Případně si můžete formulář stáhnout:\n                  "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            { staticClass: "font-size-lg" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "text-secondary",
                                                  attrs: {
                                                    href: _vm.$attrs[
                                                      "company-form-document"
                                                    ],
                                                    download: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "Žádost o poskytnutí příspěvku - právnická osoba.pdf"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedForm === "person"
                        ? _c("Person-Form", {
                            on: {
                              done: function ($event) {
                                _vm.isCompleted = true
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedForm === "company"
                        ? _c("Company-Form", {
                            on: {
                              done: function ($event) {
                                _vm.isCompleted = true
                              },
                            },
                          })
                        : _vm._e(),
                    ]
                  : [
                      _c("h2", { staticClass: "h4 text-secondary mb-5" }, [
                        _vm._v(
                          "\n            Formulář byl v pořádku odeslán. Děkujeme a budeme Vás v nejbližší\n            době kontaktovat.\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("h2", { staticClass: "h3 mb-3" }, [
                        _vm._v("Hodnocení žádostí - Kritéria hodnocení"),
                      ]),
                      _vm._v(" "),
                      _vm._m(1),
                      _vm._v(" "),
                      _vm._m(2),
                      _vm._v(" "),
                      _vm._m(3),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-4" }, [
                        _vm._v(
                          "\n            Upřednostňují se žádosti nelékařských zdravotnických pracovníků a\n            projekty zaměřené na podporu jejich vzdělávání a působení ve\n            zdravotnictví v ČR.\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("h2", { staticClass: "h3 mb-3" }, [
                        _vm._v("Uzavření smlouvy"),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n            Předkladatelé, jejichž žádost byla schválena, uzavřou s nadačním\n            fondem smlouvu, v níž se zavazují použít finanční prostředky k\n            dohodnutým účelům a za předem stanovených podmínek.\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._m(4),
                    ],
              ],
              2
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "mb-3" }, [
      _vm._v("\n            Žádosti schvaluje správní rada."),
      _c("br"),
      _vm._v(
        "\n            Příspěvek nadačního fondu není až do podpisu smlouvy oběma\n            stranami nárokovatelný. Správní rada má právo si vyžádat další\n            podklady, které jí pomohou k rozhodnutí o přidělení podpory.\n          "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "text-primary" }, [
      _c("strong", [_vm._v("V hodnocení se zohledňuje zejména:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "my-3" }, [
      _c("li", { staticClass: "HelpItem mb-2" }, [
        _vm._v(
          "\n              termín podání žádosti (dřívější datum žádosti se zohlední)\n            "
        ),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "HelpItem mb-2" }, [
        _vm._v(
          "\n              úplnost a správnost vyplnění žádosti\n            "
        ),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "HelpItem mb-2" }, [
        _vm._v(
          "\n              prokazatelný zájem o práci ve zdravotnictví v ČR, tj.\n              doložitelná doba aktivního působení ve zdravotnictví (vč.\n              odborné pedagogické činnosti) – nevztahuje se na studenty\n              prezenčních studijních programů\n            "
        ),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "HelpItem mb-2" }, [
        _vm._v(
          "\n              zaměstnanecký poměr vůči EUC (a jeho rozsah, u studentů\n              „brigády“)\n            "
        ),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "HelpItem mb-2" }, [
        _vm._v(
          "\n              přínos pro zdravotníky zejména skupiny EUC\n            "
        ),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "HelpItem mb-2" }, [
        _vm._v("míra finanční spoluúčasti žadatele"),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "HelpItem mb-2" }, [
        _vm._v(
          "\n              aktuální potřebnost projektu a jeho pozitivní vliv/přínos\n              zdravotnictví v ČR, zejména v oblasti ošetřovatelství,\n            "
        ),
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "HelpItem mb-2" }, [
        _vm._v(
          "\n              dosavadní zkušenosti předkladatele v oblasti, ve které žádost\n              podává.\n            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mt-4 text-right" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary px-5",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close",
          },
        },
        [_vm._v("\n              Zavřít\n            ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }